import React, { useEffect } from "react";

import { Button, CircularProgress, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import FlipNumbers from "react-flip-numbers";
import { isMobile } from "react-device-detect";

import useStyles from ".././Header.styles";
import { startPoll } from "../../../redux-saga/redux/profile/myProfile";
import {
  resetSuccess,
  thirdPartyTokenLoginStart
} from "../../../redux-saga/redux/auth/authentication";
import session from "../../../utils/session";
import { agentBetcoinTokenRoles } from "../../../utils/constants";

const Wallet = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { walletAmount, walletLoading, agentDetails } = useSelector(
    (state) => state.myProfile
  );

  const { thirdPartyRedirectUrl } = useSelector(
    (state) => state.authentication
  );

  useEffect(() => {
    if (thirdPartyRedirectUrl) {
      window.location.href = thirdPartyRedirectUrl;
    }
  }, [thirdPartyRedirectUrl]);

  useEffect(() => {
    const user = session.getSessionCred;
    dispatch(startPoll(user.userId));
    // dispatch(pusherStart());
    dispatch(resetSuccess());
  }, [dispatch]);

  const betCoinTokenPermission =
    agentDetails?.roles?.filter((rolesData) => {
      return agentBetcoinTokenRoles?.find((abbr) => rolesData?.abbr === abbr);
    })?.length === agentBetcoinTokenRoles?.length;

  return (
    <Grid
      className={`${classes.balanceBtnWrap} ${betCoinTokenPermission ? classes.balanceBoatBtn : ""}`}
      onClick={() => {
        if (betCoinTokenPermission) {
          dispatch(thirdPartyTokenLoginStart());
        }
      }}
    >
      {betCoinTokenPermission && (
        <div className={classes.iconWrap}>
          <span className={`${classes.iconStyle} ${classes.iconPlusStyle}`}>
            +
          </span>
          <span className={classes.iconStyle}>-</span>
        </div>
      )}
      <Button
        className={`${classes.btnPrimary} ${betCoinTokenPermission ? classes.botagentUserBalance : classes.userBalance}`}
      >
        {/* <span>
          <img src="/images/wallet.svg" alt="Wallet icon" />
        </span> */}
        {walletLoading ? (
          <CircularProgress size={25} />
        ) : (
          <>
            <div className={classes.coinWraper}>
              <img
                width="23"
                height="23"
                src="/images/coin.webp"
                alt="Coin Icon"
              />
            </div>
            <div>
              <FlipNumbers
                height={isMobile ? 11 : 12}
                width={isMobile ? 7.4 : 9}
                play
                duration={2}
                perspective={isMobile ? 500 : 1000}
                numbers={`${walletAmount}`}
                numberStyle={{
                  fontSize: `${isMobile ? "11px" : "14px"}`,
                  fontWeight: "600"
                }}
                nonNumberStyle={{
                  width: "0",
                  marginLeft: "2px",
                  marginRight: "2px",
                  padding: "0",
                  justifyContent: "center"
                }}
              />
            </div>
          </>
        )}
      </Button>
    </Grid>
  );
};

export default Wallet;
